import { cn } from "@/lib/utils";
import { Star, Coins, Trophy, Medal, Fire, Lightning, SealCheck, Lock } from "@phosphor-icons/react";

/* ---------------------------------- XP Badge ------------------------------------- */
export function XPBadge({ amount = 15, size = "md" }) {
  const sm = size === "sm";
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full bg-secondary/25 font-bold text-secondary-ink", sm ? "px-2.5 py-1 text-xs" : "px-3.5 py-1.5 text-sm")}>
      <Star size={sm ? 14 : 16} weight="fill" /> {amount} XP
    </span>
  );
}

/* --------------------------------- Coin Badge ------------------------------------ */
export function CoinBadge({ amount = 120, size = "md" }) {
  const sm = size === "sm";
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full bg-primary/12 font-bold text-primary-strong", sm ? "px-2.5 py-1 text-xs" : "px-3.5 py-1.5 text-sm")}>
      <Coins size={sm ? 14 : 16} weight="fill" /> {amount}
    </span>
  );
}

/* ------------------------------ Achievement Badge -------------------------------- */
export function AchievementBadge({ icon: Icon = Medal, label = "Star Reader", color = "primary", unlocked = true }) {
  const tints = {
    primary: "bg-primary/12 text-primary-strong ring-primary/20",
    teal: "bg-teal/15 text-teal-ink ring-teal/20",
    blue: "bg-blue/12 text-blue-ink ring-blue/20",
    secondary: "bg-secondary/25 text-secondary-ink ring-secondary/30",
  };
  return (
    <div className="flex flex-col items-center gap-2 text-center">
      <span className={cn("flex h-16 w-16 items-center justify-center rounded-full ring-4", unlocked ? tints[color] : "bg-muted text-muted-foreground ring-transparent")}>
        {unlocked ? <Icon size={30} weight="fill" /> : <Lock size={26} weight="bold" />}
      </span>
      <span className={cn("text-sm font-bold", unlocked ? "text-foreground" : "text-muted-foreground")}>{label}</span>
    </div>
  );
}

/* --------------------------------- Trophy Card ----------------------------------- */
export function TrophyCard({ title = "Maths Champion", subtitle = "Top of the class this week!" }) {
  return (
    <div className="relative overflow-hidden rounded-3xl border border-border bg-gradient-to-b from-secondary/25 to-card p-6 text-center shadow-soft">
      <div aria-hidden className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-secondary/20 to-transparent" />
      <div className="relative flex flex-col items-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-secondary/30 text-secondary-ink ring-8 ring-secondary/15">
          <Trophy size={40} weight="fill" />
        </span>
        <p className="mt-3 font-display text-xl font-extrabold">{title}</p>
        <p className="text-sm font-semibold text-muted-foreground">{subtitle}</p>
      </div>
    </div>
  );
}

/* --------------------------------- Streak Badge ---------------------------------- */
export function StreakBadge({ days = 7, size = "md" }) {
  const sm = size === "sm";
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full bg-primary/12 font-bold text-primary-strong", sm ? "px-2.5 py-1 text-xs" : "px-3.5 py-1.5 text-sm")}>
      <Fire size={sm ? 14 : 16} weight="fill" /> {days} day streak
    </span>
  );
}

export { Lightning, SealCheck };
